import {
  ClientConfig,
  LightboxHandle,
  useMySPHLightbox,
  User,
} from "@sphtech/idpf-lightbox-react";

export type { ClientConfig, LightboxHandle, User };
export default useMySPHLightbox;
